<template>
  <el-popover
    :visible-arrow="false"
    trigger="focus"
    width="350"
    placement="bottom-start"
    popper-class="weekly-day-select"
    :disabled="disabled"
  >
    <div class="schedule-box">
      <el-form-item :label="$locale('global.all')">
        <el-checkbox v-model="scheduleData.all" :checked="scheduleData.all" @change="allChangeAction"></el-checkbox>
      </el-form-item>
      <el-form-item :label="$locale('calendar.week')">
        <el-checkbox-group v-model="scheduleData.week" :disabled="scheduleData.all">
          <el-checkbox v-for="obj in weekOptions" :label="obj.value" :key="obj.value">{{obj.label}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item :label="$locale('calendar.month')">
        <el-checkbox-group v-model="scheduleData.month" :disabled="scheduleData.all">
          <el-checkbox v-for="obj in monthOptions" :label="obj.value" :key="obj.value">{{obj.label}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </div>
    <el-input slot="reference" readonly v-model="scheduleText"></el-input>
  </el-popover>
</template>

<script>
import tranfResData from "@/utils/tranfResData";
import { weekSelectArray, weekLocaleArray } from "@/utils/common";

export default {
  name: "weekly-day-select",
  props: {
    action: {
      type: String,
      default: null,
    },
    scheduleData: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      weekOptions : weekSelectArray,
    };
  },
  computed: {
    monthOptions() {
      let options = [];
      for (let i = 1; i < 32; i++) {
        options.push({
          value: i.toString(),
          label: i + this.$locale("calendar.day"),
        });
      }
      return options;
    },
    scheduleText() {
      return this.getText();
    },
  },
  methods: {
    getText() {
      const obj = tranfResData(this.scheduleData);
      let text = "";
      let weekText = "";
      let monthText = "";

      if (obj.all) {
        return this.$locale("global.all");
      } else if (!obj.all && obj.week.length === 0 && obj.month.length === 0) {
        return this.$locale('global.none');
      }

      if (obj.week.length > 0) {
        weekText = this.$locale("calendar.weekly");

        obj.week.forEach(_week => {
          weekText = weekText + weekLocaleArray[_week] + "、";
        });

        weekText = weekText.substring(0, weekText.length - 1);
        weekText += this.$locale("calendar.weekday");
      }

      if (obj.month.length > 0) {
        monthText = this.$locale("calendar.monthly");

        obj.month.forEach(_month => {
          monthText = monthText + _month + "、";
        });

        monthText = monthText.substring(0, monthText.length - 1);
        monthText += this.$locale("calendar.day");
      }

      if (weekText !== "" && monthText !== "") {
        text = monthText + " / " + weekText;
      } else {
        text = monthText + weekText;
      }

      return text;
    },
    allChangeAction(_value) {
      if (_value) {
        this.scheduleData.month = [];
        this.scheduleData.week = [];
      }
    },
  },
};
</script>

<style scoped lang="less">
.weekly-day-select {
  .schedule-box {
    flex: 1 1;
    max-height: 300px;
    padding: 0 10px;
    overflow-y: auto;

    ::v-deep .el-form-item__content {
      margin: 0;
      vertical-align: middle;
      line-height: 40px;

      .el-checkbox-group {
        display: inline-block;
        width: 100%;
      }
    }

    ::v-deep .el-form-item .el-form-item {
       margin-bottom: 20px;
    }
  }

}
</style>